import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String, name: String }

  connect() {
    const selectElement = document.querySelector("#assignment_client_company_id")

    if (selectElement && selectElement.selectize) {
      const selectize = selectElement.selectize

      if (!selectize.options[this.idValue]) {
        selectize.addOption({ value: this.idValue, text: this.nameValue })
      }

      selectize.addItem(this.idValue)
    }

    this.element.remove() // keep DOM clean
  }
}
